import {bindable, customElement, InlineViewStrategy} from 'aurelia-framework';

@customElement('sio-html')

export class HtmlField {

    @bindable config;

    bind(context) {
        this.context = context;
        this.regex = this.config?.options?.regex;
        if (this.regex) {
            window.addEventListener("message", this.onMessage.bind(this), false);
        }
        if (this.config.options.hasOwnProperty("customBody")) {
            this.config.viewStrategy = new InlineViewStrategy('<template>' + this.config.options.customBody + '</template>');
        }
    }

    onMessage(event) {
        const str = JSON.stringify(event.data);
        if (new RegExp(this.regex).test(str)) {
            this.config?.setValue(str);
        }
    }

    deactivate() {
        window.removeEventListener("message", this.onMessage);
    }
}
